// passwordValidation.js
//
// Single source of truth for password strength, used everywhere a password gets set: company
// signup, an admin creating/resetting a user's password, a self-service reset link, and a
// user's own "change password" screen. Client-side checks here are for immediate feedback only
// — the same rule is also enforced server-side (functions/passwordValidation.js), since a
// client-side check alone is never real enforcement.
export const MIN_PASSWORD_LENGTH = 6;

export const PASSWORD_REQUIREMENTS_TEXT =
  `At least ${MIN_PASSWORD_LENGTH} characters, with one uppercase letter, one number, and one special character.`;

// Returns null when the password is valid, otherwise a user-facing error message.
export const getPasswordError = (password) => {
  const value = password || '';
  if (value.length < MIN_PASSWORD_LENGTH) return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  if (!/[A-Z]/.test(value)) return 'Password must include at least one uppercase letter.';
  if (!/[0-9]/.test(value)) return 'Password must include at least one number.';
  if (!/[^A-Za-z0-9]/.test(value)) return 'Password must include at least one special character.';
  return null;
};

export const isPasswordValid = (password) => getPasswordError(password) === null;
